import { render, staticRenderFns } from "./CheckpointTableNotificationsWrapper.vue?vue&type=template&id=795c920f&scoped=true&"
import script from "./CheckpointTableNotificationsWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckpointTableNotificationsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointTableNotificationsWrapper.vue?vue&type=style&index=0&id=795c920f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c920f",
  null
  
)

export default component.exports